export default "__VITE_ASSET__CWR73eEo__"